import React, { useState } from 'react';
import { Badge } from '../../ui/badge';
import { ChevronDown, ChevronRight, Lock, Unlock } from 'lucide-react';
import { DisputeDetail } from './DisputeDetail';
import { STATUS, GATEWAY, KIND, fmtDia, fmtMoeda, dataPix, nomeCliente, docCliente, totaisTexto }
  from './disputeUtils';

const CABECALHO = ['', 'Data do Pix', 'Gateway', 'Resultado', 'Cliente', 'KAKO ID',
  'Documento', 'Valor', 'Motivo', 'Pedido', 'Situação'];

const Th = ({ children, onClick, ativo }) => (
  <th onClick={onClick}
      className={`px-3 py-2 text-left font-semibold whitespace-nowrap ${onClick ? 'cursor-pointer select-none hover:text-gray-900' : ''} ${ativo ? 'text-gray-900' : ''}`}>
    {children}{ativo ? ' ↓' : ''}
  </th>
);

export const DisputesTable = ({ disputes, agir, acting, notes, setNotes, onReload }) => {
  const [aberta, setAberta] = useState(null);
  const [ordem, setOrdem] = useState('data');

  const lista = [...disputes].sort((a, b) => (ordem === 'valor'
    ? Number(b.amount || 0) - Number(a.amount || 0)
    : String(dataPix(b) || '').localeCompare(String(dataPix(a) || ''))));

  return (
    <div className="rounded-xl border bg-white overflow-x-auto" data-testid="disputes-table-wrap">
      <table className="w-full min-w-[1100px] text-sm" data-testid="disputes-table">
        <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
          <tr>
            {CABECALHO.map((t) => (
              t === 'Data do Pix' ? <Th key={t} onClick={() => setOrdem('data')} ativo={ordem === 'data'}>{t}</Th>
                : t === 'Valor' ? <Th key={t} onClick={() => setOrdem('valor')} ativo={ordem === 'valor'}>{t}</Th>
                  : <Th key={t}>{t}</Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {lista.map((d) => (
            <React.Fragment key={d.id}>
              <tr onClick={() => setAberta(aberta === d.id ? null : d.id)}
                  data-testid={`dispute-row-${d.id}`}
                  className={`border-t cursor-pointer transition-colors hover:bg-amber-50/70 ${aberta === d.id ? 'bg-amber-50' : ''}`}>
                <td className="px-2 py-2 text-gray-400">
                  {aberta === d.id ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">{fmtDia(dataPix(d))}</td>
                <td className="px-3 py-2 whitespace-nowrap text-xs">
                  {GATEWAY[d.gateway] || d.gateway}
                  <span className="block text-gray-500">{KIND[d.kind] || d.kind}</span>
                </td>
                <td className="px-3 py-2">
                  <Badge className={STATUS[d.status]?.cls || 'bg-gray-500 text-white'}>
                    {STATUS[d.status]?.label || d.status}
                  </Badge>
                  {d.result_note && (
                    <span className="block text-[11px] text-gray-500 max-w-[220px] truncate"
                          title={d.result_note}>{d.result_note}</span>
                  )}
                </td>
                <td className="px-3 py-2 max-w-[190px] truncate" title={nomeCliente(d)}>
                  {nomeCliente(d)}
                  {!d.order_id && (d.payer_name || d.payer_document)
                    && <span className="block text-[11px] text-gray-400">(dados do Pix)</span>}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">{d.kako_id || '-'}</td>
                <td className="px-3 py-2 whitespace-nowrap">{docCliente(d)}</td>
                <td className="px-3 py-2 whitespace-nowrap font-medium">{fmtMoeda(d.amount, d.currency)}</td>
                <td className="px-3 py-2 max-w-[200px] truncate" title={d.reason || ''}>{d.reason || '-'}</td>
                <td className="px-3 py-2 whitespace-nowrap text-xs">
                  {d.order_id ? d.order_id.slice(0, 8)
                    : <span className="text-gray-400">não localizado</span>}
                </td>
                <td className="px-3 py-2">
                  {d.blocked_now
                    ? <span className="inline-flex items-center gap-1 text-red-700 text-xs font-medium">
                        <Lock className="h-3 w-3" /> bloqueado</span>
                    : <span className="inline-flex items-center gap-1 text-emerald-700 text-xs">
                        <Unlock className="h-3 w-3" /> liberado</span>}
                </td>
              </tr>
              {aberta === d.id && (
                <tr className="bg-amber-50/40">
                  <td colSpan={CABECALHO.length} className="p-0">
                    <DisputeDetail d={d} agir={agir} acting={acting} notes={notes}
                                   setNotes={setNotes} onReload={onReload} />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          {lista.length === 0 && (
            <tr><td colSpan={CABECALHO.length} className="px-3 py-6 text-center text-gray-500"
                    data-testid="disputes-table-empty">
              Nenhuma contestação com esses filtros.
            </td></tr>
          )}
        </tbody>
        {lista.length > 0 && (
          <tfoot className="bg-gray-50 border-t">
            <tr className="text-xs text-gray-600">
              <td colSpan={7} className="px-3 py-2 font-medium" data-testid="disputes-table-count">
                {lista.length} contestação(ões) na visão atual
              </td>
              <td className="px-3 py-2 font-bold whitespace-nowrap" data-testid="disputes-table-total">
                {totaisTexto(lista)}
              </td>
              <td colSpan={3} />
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
};

export default DisputesTable;
